import { createContext } from "react";
const NotificationBoxContext = createContext();

export default NotificationBoxContext;
